var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"router-animation","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath,ref:"content",attrs:{"id":"PageWrapper"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }